import React, { useState, useEffect } from "react";
import "./multimediaItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile, faEdit } from "@fortawesome/free-solid-svg-icons";
//import { t } from "i18next";
import { MultimediaService } from "../multimedia.service";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import Modal from "../../commons/modal/modal";
import MessageManager from "../../commons/message/messageManager";
import { TYPE_MESSAGE } from "../../../utils/Constant";
import {isAudio, isImage, isVideo} from '../../../utils/ValidationTypeFile';

export default function MultimediaForm(props) {
    const { showModal, setShowModal, onChangeModal, isEdit, value } = props;
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [selectedImageFile, setSelectedImageFile] = useState(null);
    const [selectedImagePreviewContent, setSelectedImagePreviewContent] = useState(null);
    const [videoKey1, setVideoKey1] = useState(Date.now());
    const [videoKey2, setVideoKey2] = useState(Date.now() + 1);
    const [errorMessages, setErrorMessages] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false); // Variable de estado para controlar la carga

    const [messageManagerState, setMessageManagerState] = useState({
        show: false,
        type: TYPE_MESSAGE.INFO,
        title: "a",
        messageText: "b",
    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValuesData(value),
        validationSchema: Yup.object({
            apply_blur: Yup.boolean(),
            preview_content: Yup.mixed(),
            file: Yup.mixed()
            .required('El archivo es requerido'),
        }),
        onSubmit: async (values) => {
            try {
                setIsSubmitting(true); // Activar la carga
                if (isEdit) {
                    const dataItem = await MultimediaService("PUT", values, selectedImageFile, selectedImagePreviewContent);
                    props.onChangeModal(dataItem);
                    handleMessage(true, "", t("saveMessage"), TYPE_MESSAGE.SUCCESS);
                    setShowModal(false);
                } else {
                    const dataItem = await MultimediaService("POST", values, selectedImageFile, selectedImagePreviewContent);
                    onChangeModal(dataItem);
                    handleMessage(true, "", t("saveMessage"), TYPE_MESSAGE.SUCCESS);
                    setShowModal(false);
                }

                formik.resetForm(); // Reset Formik values and state
                setSelectedImageFile(undefined); // Reset selectedImageFile state
                setSelectedImagePreviewContent(undefined); // Reset selectedImagePreviewContent state
                setIsSubmitting(false);
            } catch (error) {
                setIsSubmitting(false);
                if (error.message === "exit") {
                    navigate("/");
                } else {
                    setErrorMessages(error);
                }
            }
        },
    });

    const handleMessage = (show, title, messageText, type) => {
        setMessageManagerState({
            show: show,
            type: type,
            title: title,
            messageText: messageText,
        });
        setTimeout(() => {
            setMessageManagerState({
                show: false,
                type: TYPE_MESSAGE.INFO,
                title: "",
                messageText: "",
            });
        }, 3000);
    };

    useEffect(() => {
        formik.setValues(initialValuesData(value));
    }, [value]);

    return (
        <form onSubmit={formik.handleSubmit}>
            <MessageManager
                show={messageManagerState.show}
                title={messageManagerState.title}
                messageText={messageManagerState.messageText}
                type={messageManagerState.type}
                onClose={() => {
                    setMessageManagerState({
                        show: false,
                        type: TYPE_MESSAGE.INFO,
                        title: "a",
                        messageText: "b",
                    });

                }}
            />
            {showModal && (
                <Modal
                    title="Subir archivos al pack"
                    footer={
                        <div className="btn-save-multimedia">
                            <button type="submit" disabled={isSubmitting}>
                                
                                {isSubmitting ? t("Guardando...") : t("Guardar")}
                                </button>
                        </div>
                    }

                    setShow={setShowModal}
                    show={showModal}
                    onCloseModal={() => {
                        formik.resetForm(); // Reset Formik values and state
                        setSelectedImageFile(null); // Reset selectedImageFile state
                        setSelectedImagePreviewContent(null); // Reset selectedImagePreviewContent state

                    }}
                >
                    <div className="item-multimedia-body">
                        <div className="container-file-form">
                            <div className="input-data profile-item-imagen-select-pack">
                                <span className="margin-left">Archivo de Pago </span>
                                <input
                                    id="files"
                                    type="file"
                                    name="file"
                                    onChange={(event) => {
                                        const file = event.target.files[0];
                                        if (file && file.size <= 10 * 1024 * 1024) {
                                            formik.handleChange(event);
                                            setSelectedImageFile(file);
                                            setVideoKey2(Date.now());
                                        } else {
                                            alert('El archivo es demasiado grande ')
                                            // Mostrar mensaje de error de tamaño de archivo aquí
                                        }

                                        //formik.handleChange(event);
                                        if (selectedImageFile) {
                                            URL.revokeObjectURL(selectedImageFile);
                                        }

                                      //  setSelectedImageFile(event.target.files[0]);
                                      //  setVideoKey2(Date.now())
                                    }}
                                />
                                <div className="container-file-item ">
                                    <label htmlFor="files" className="item-edit-multimedia">
                                        <FontAwesomeIcon icon={(!selectedImagePreviewContent && !formik.values.preview_content) ? faFile : faEdit} className="icon-item-edit" />
                                    </label>
                                    {!selectedImageFile && !formik.values.file && (
                                        <div className="item-image-pack">
                                            <div className="item-text-file">{t("Seleccione un archivo")} </div>
                                        </div>
                                    )}
                                    {formik.values.file && isImage(formik.values.file) && (
                                        <img
                                            alt="not found"
                                            className="preview-file"
                                            src={selectedImageFile
                                                ? URL.createObjectURL(selectedImageFile)
                                                : formik.values.file
                                            }
                                        />
                                    )}

                                    {formik.values.file && isVideo(formik.values.file) && (
                                        <video className="profile-video-pack" key={videoKey2} controls>
                                            <source
                                                src={selectedImageFile
                                                    ? URL.createObjectURL(selectedImageFile)
                                                    : formik.values.file
                                                }

                                                type={formik.values.file.type}
                                            />
                                            {t("Tu navegador no admite la reproducción de videos.")}
                                        </video>
                                    )}

                                    {formik.values.file && isAudio(formik.values.file) && (
                                        <div className="audio-player">
                                            <audio controls>
                                                <source
                                                    src={
                                                        selectedImagePreviewContent
                                                            ? URL.createObjectURL(selectedImagePreviewContent)
                                                            : formik.values.file
                                                    }
                                                    type={formik.values.file.type}
                                                />
                                                {t("Your browser does not support audio playback.")}
                                            </audio>
                                        </div>
                                    )}
                                </div>
                                {/* {formik.errors.file ? (
                                    <div className="error-pack">{formik.errors.file}</div>
                                ) : (
                                    <div className="error-pack"></div>
                                )} */}


                                {formik.touched.file && formik.errors.file && (
                                    <div className="error-pack">{formik.errors.file}</div>
                                )}


                            </div>
                            <div className="input-data profile-item-imagen-select-pack margin-left">
                                <span>Archivo Gratuito</span>
                                <input
                                    id="preview_content"
                                    type="file"
                                    name="preview_content"
                                    accept={
                                        isVideo(formik.values.file)
                                            ? "video/*, image/*"
                                            : isAudio(formik.values.file)
                                                ? "audio/*, image/*"
                                                : "image/*"
                                    }
                                    onChange={(event) => {
                                        if (selectedImagePreviewContent) {
                                            URL.revokeObjectURL(selectedImagePreviewContent);
                                        }
                                      



                                        const file = event.target.files[0];
                                        if (file && file.size <= 10 * 1024 * 1024) {
                                            formik.handleChange(event);
                                            setSelectedImagePreviewContent(event.target.files[0]);
                                            setVideoKey1(Date.now())
                                        } else {
                                            alert('El archivo es demasiado grande ')
                                            // Mostrar mensaje de error de tamaño de archivo aquí
                                        }


                                    }}
                                />
                                <div className={`container-file-item margin-rigth 
                                ${((formik.values.apply_blur && isVideo(formik.values.file)) ? 'opacity-disabled' : '') ||
                                        (!formik.values.file) ? 'opacity-disabled' : ''}`}>
                                    <label htmlFor="preview_content" className="item-edit-multimedia">
                                        <FontAwesomeIcon icon={(!selectedImagePreviewContent && !formik.values.preview_content) ? faFile : faEdit} className="icon-item-edit" />
                                    </label>
                                    {!selectedImagePreviewContent && !formik.values.preview_content && (
                                        <div className="item-image-pack">
                                            <div className="item-text-file">{t("Seleccione un archivo")} </div>{" "}
                                        </div>
                                    )}


                                    {// Cuando es una Imagen
                                        formik.values.preview_content && isImage(formik.values.preview_content) && (
                                            <>                                                <img
                                                alt="not found"
                                                className={`preview-file  ${(formik.values.apply_blur && !isVideo(formik.values.file)) &&
                                                    (!isVideo(formik.values.preview_content))
                                                    ? 'scale-distorted' : ''
                                                    }`}

                                                src={selectedImagePreviewContent
                                                    ? URL.createObjectURL(selectedImagePreviewContent)
                                                    : formik.values.preview_content
                                                }
                                            />
                                            </>
                                        )}

                                    { // Cuando es un video
                                        formik.values.preview_content && isVideo(formik.values.preview_content) && (
                                            <video className="profile-video-pack" controls
                                                key={videoKey1}
                                            >
                                                <source

                                                    src={selectedImagePreviewContent
                                                        ? URL.createObjectURL(selectedImagePreviewContent)
                                                        : formik.values.preview_content
                                                    }
                                                    type={formik.values.preview_content.type}
                                                />
                                                {t("Tu navegador no admite la reproducción de videos.")}
                                            </video>
                                        )}

                                    {formik.values.preview_content && isAudio(formik.values.preview_content) && (
                                        <div className="audio-player">
                                            <audio controls>
                                                <source
                                                    src={
                                                        selectedImagePreviewContent
                                                            ? URL.createObjectURL(selectedImagePreviewContent)
                                                            : formik.values.preview_content
                                                    }
                                                    type={formik.values.preview_content.type}
                                                />
                                                {t("Your browser does not support audio playback.")}
                                            </audio>
                                        </div>
                                    )}

                                </div>



                                {formik.touched.preview_content && formik.errors.preview_content && (
                                    <div className="error-pack">{formik.errors.preview_content}</div>
                                )}


                            </div>
                        </div>

                        <div className={` profile-item-imagen-select-pac  ${isAudio(formik.values.file) ? 'opacity-disabled' : ''}`}>
                            <input type='checkbox' name='apply_blur' id="apply_blur"
                                checked={formik.values.apply_blur}
                                onChange={(event) => {
                                    formik.setFieldValue('apply_blur', event.currentTarget.checked);
                                    if (isVideo(formik.values.file)) {
                                        URL.revokeObjectURL(selectedImagePreviewContent);
                                        setSelectedImagePreviewContent(null);
                                        formik.values.preview_content = null
                                    }
                                }}
                            />
                            <label for='apply_blur'>Aplicar desenfoque </label>
                        </div>
                    </div>
                </Modal>
            )}
        </form>
    );
}

function initialValuesData(dataInitial) {
    return {
        id: dataInitial && dataInitial.id ? dataInitial.id : null,
        pack_multimedia: dataInitial && dataInitial.pack_multimedia ? dataInitial.pack_multimedia : null,
        file: dataInitial && dataInitial.file ? dataInitial.file : "",
        preview_content: dataInitial && dataInitial.preview_content ? dataInitial.preview_content : "",
        apply_blur: dataInitial && dataInitial.hasOwnProperty('apply_blur') ? dataInitial.apply_blur : false,
    };
}